import { defineStore, storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useBaseRatingStore } from '@/shared/stores/BaseRatingStore';

export const useRatingStore = defineStore('profile-page-rating-store', () => {
  const { rating, reviewList, showRating } = storeToRefs(useBaseRatingStore());
  const lastReview = computed(() => reviewList.value[0] ?? null);

  return {
    rating,
    reviewList,
    lastReview,
    showRating,
  };
});
